import { gsap, ScrollToPlugin } from 'gsap/all';
import Logger from './logger';

class MixtapeMain extends HTMLElement {
  #NAME ='MixtapeMain';
  #abortController;
  #mixtapeCurrent;
  #mixtapeList;
  #loadAnim;
  #gifDiv
  #data;
  #playerWrap;
  #player;
  #numberEl;
  #titleEl;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    gsap.registerPlugin(ScrollToPlugin);
    this.#mixtapeCurrent = this.querySelector('mixtape-current');
    this.#mixtapeList = this.querySelector('mixtape-list');
    this.#loadAnim = this.querySelector('mixtape-load-anim');
    this.#gifDiv = this.querySelector('#mixtapes-gif-container');
    this.#playerWrap = this.querySelector('#mixtapes-player-wrap');
    this.#player = this.querySelector('mixtape-player');
    this.#numberEl = this.#playerWrap.querySelector('.mixtapes__player-wrap__number span');
    this.#titleEl= this.#playerWrap.querySelector('.mixtapes__player-wrap__title');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    let searchParams = new URLSearchParams(window.location.search);
    let index = searchParams.get('index'); console.log(index)
    if (index) index = parseInt(index);
    searchParams = null;
    //
    window.addEventListener("popstate", (e) => this.#updateState(e.state.index, true), { signal });
    window.addEventListener('resize', () => this.#onResize(), { signal });
    this.addEventListener('mixtape:switch', (e) => this.#updateState(e.detail.index), { signal });
    this.addEventListener('mixtape:current:ready', () => this.#updateState(index, true), { signal });
    this.addEventListener('mixtape:list:ready', () => {
      gsap.to(this.#loadAnim, { 
        opacity: 0, 
        duration: 1,
        delay: 1.6,
        ease: 'power1.out', 
        onComplete: () => {
          this.#loadAnim.remove();
          this.#loadAnim = null;
        }
      })
    }, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['json'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.#NAME} > attributeChangedCallback > name: ${name}`);
    if (name === 'json') {
      this.#data = JSON.parse(newValue);
      this.#player.dataset.playlists = JSON.stringify(this.#data.map(obj => obj.playlist));
      console.log(this.#data);
    }
  }

  #updateState(index, replace = false) {
    Logger.info(`${this.#NAME} > #updateState > index: ${index} > replace: ${replace}`);
    if (replace) {
      window.history.replaceState({ index }, '', `${window.location.pathname}${index !== null ? `?index=${index}` : ''}`);
    } else {
      window.history.pushState({ index }, '', `${window.location.pathname}?index=${index}`);
    }
    //
    if (!this.#mixtapeList.data) this.#mixtapeList.data = this.#data;
    //
    if (index !== null) {
      console.log(this.#data[index]);
      this.#mixtapeCurrent.setCard(this.#data[index].card, this.#data[index].sticker);
      this.#mixtapeList.dataset.current = index;
      /* this.#player.dataset.index = index; */
      this.#titleEl.textContent = this.#data[index].title;
      this.#numberEl.textContent = this.#data[index].number;
      this.#gifDiv.style.backgroundImage = `url(${this.#data[index].gif})`;
      if (this.dataset.reveal === 'false') {
        this.#player.dataset.index = index;
        this.dataset.reveal = 'true';
        setTimeout(() => {
          this.#onResize();
          this.#mixtapeCurrent.dataset.show = 'true';
          this.#playerWrap.dataset.show = 'true';
        }, 1600);
      } else {
        gsap.timeline({ smoothChildTiming: true })
          .to(this.#player, { 
            opacity: 0,
            duration: 0.6,
            ease: 'power2.in', 
          })
          .to(window, { 
            duration: 1, 
            ease: 'power2.out', 
            scrollTo: this.#mixtapeCurrent 
          }, '-=0.4')
          .call(() => this.#player.dataset.index = index)
          .to(this.#player, { 
            opacity: 1, 
            duration: 0.6,
            ease: 'power2.out',
          }, '+=1');
      }
    } /* else {
      gsap.to(window, { 
        duration: 1, 
        ease: 'power2.out', 
        scrollTo: this.#mixtapeCurrent 
      });
    } */
  }

  #onResize() {
    Logger.info(`${this.#NAME} > #onResize`);
    this.#mixtapeCurrent.onResize();
    this.#mixtapeList.onResize();
  }

}

customElements.define('mixtape-main', MixtapeMain);